var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a-icon',{style:({color:_vm.ori_collect?_vm.lightColor:'#e0e0e0',fontSize:_vm.size+'px'}),attrs:{"type":_vm.iconType,"theme":"filled"},on:{"click":function($event){$event.stopPropagation();return _vm.CollectNow(_vm.id)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f6e5a5b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/todoCenter/collect.vue
// module id = null
// module chunks = 